'use strict';

const JuiceProgramModel = require('./models/juice_program');
const JuiceProgramView = require('./views/juice_program');
const { inlineSelectors, modalSelectors } = require('./views/constants');

const JuiceProgram = {
  init({ juiceProgramInfo }, done = function() {}) {
    if (juiceProgramInfo && juiceProgramInfo.isJuiceProgramEnabled) {
      const model = new JuiceProgramModel(juiceProgramInfo);

      if (document.querySelector(inlineSelectors.wrapper)) {
        const inlineJuiceView = new JuiceProgramView({
          model,
          selectors: inlineSelectors,
        });
        inlineJuiceView.render();
      }

      if (document.querySelector(modalSelectors.wrapper)) {
        const modalJuiceView = new JuiceProgramView({
          isOverlay: true,
          model,
          selectors: modalSelectors,
        });
        modalJuiceView.render();
      }
    }
    done();
  },
};

module.exports = JuiceProgram;
